import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useUser } from '../contexts/UserContext';
import { supabase } from '../lib/supabase';
import Sidebar from './Sidebar';
import Loading from './Loading';

export function Payment() {
  const { profile, loading } = useUser();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubscribe = async () => {
    if (!profile) return;
    setProcessing(true);
    setError(null);

    try {
      // Here you would integrate with your payment processor (e.g., Stripe)
      // For now, we'll simulate a successful payment
      const { error: updateError } = await supabase
        .from('profiles')
        .update({
          is_premium: true,
          premium_until: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
        })
        .eq('id', profile.id);

      if (updateError) throw updateError;

      // Refresh user context
      window.location.reload();
    } catch (err) {
      console.error('Payment error:', err);
      setError('Failed to process payment. Please try again.');
    } finally {
      setProcessing(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Sidebar user={profile || { name: '', email: '', role: '', avatar_url: '', is_premium: false }} />
      <Box sx={{ flexGrow: 1, p: 4 }}>
        <Typography variant="h4" fontWeight={700} mb={3}>Upgrade to Premium</Typography>
        
        <Card sx={{ maxWidth: 600, mx: 'auto', borderRadius: 3 }}>
          <CardHeader
            title="Premium Plan"
            subheader="Unlock all features for just $1/month"
          />
          <CardContent>
            <Typography variant="h6" mb={2}>Premium Features:</Typography>
            <ul>
              <li>Access to Forum discussions</li>
              <li>Article comments and interactions</li>
              <li>Advanced search capabilities</li>
              <li>Priority support</li>
              <li>And more coming soon!</li>
            </ul>

            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleSubscribe}
                disabled={processing || profile?.is_premium}
                sx={{ minWidth: 200 }}
              >
                {processing ? 'Processing...' : profile?.is_premium ? 'Already Premium' : 'Subscribe Now'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
} 